export const GUID_EMPTY = "00000000-0000-0000-0000-000000000000";

export const EMBEDDED_UA_MARKER = "CPLPortalApp";
export const EMBEDDED_LOGOUT_CHANNEL = "cplLogout";
export const EMBEDDED_DELETE_ACCOUNT_CHANNEL = "cplDeleteAccount";
